import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {Button, Fade, Container, Col, Row} from 'react-bootstrap';
import CommonMetaTag from './common-meta-tag';
import {reportPlayers} from '../actions/partner';
import 'react-datepicker/dist/react-datepicker.css';
import {useTranslation} from 'react-i18next';

const PartnerReportPlayers = ({createReport}) => {
  const {t} = useTranslation();

  return (
    <Fragment>
      <CommonMetaTag/>
      <Fade in appear className="partner-report-skywork-content">
        <Container fluid>
          <Row className="justify-content-center">
            <Col xs={12} lg={9} xl={8}>
              <section className="partner-report-skywork-card partner-report-skywork-player-card">
              <div className="partner-report-skywork-card-head"><span className="partner-report-skywork-card-icon"><i className="fa fa-users"/></span><div><h2>{t('LIST_PLAYER')}</h2><p>{t('LIST_PLAYER_DOWNLOAD_PARTNER')}</p></div></div>
              <Button type="button" className="partner-report-skywork-primary" onClick={createReport}><i className="fa fa-download"/> {t('EXTRACT_XLS')}</Button>
              </section>
            </Col>
          </Row>
        </Container>
      </Fade>
    </Fragment>
  );
};

PartnerReportPlayers.propTypes = {
  createReport: PropTypes.func.isRequired
};

const mapStateToProps = () => ({
});
  
const mapDispatchToProps = dispatch => ({
    createReport:() => {
      dispatch(reportPlayers());
    }
});
  
export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(PartnerReportPlayers));
